import {Component, Injector, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Log, LogTag} from '../../services/Log';
import {concatMap, filter, interval, Observable, of, switchMap} from "rxjs";
import {delay, take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";

@Component({
    selector: 'app-check-is-installed',
    templateUrl: './check.is.installed.component.html',
    styleUrls: ['../reg-dialog/reg.dialog.component.css', './check.is.installed.component.css']
})
export class CheckIsInstalledComponent extends RegDialogComponent implements OnInit {
  constructor(protected injector: Injector) {
    super(injector);
  }

  waitCount = 120;

  ngOnInit() {
  }

  readyToInstall(): Observable<any> {
    return interval(1000).pipe(
      concatMap(r => {
        this.waitCount--;
        this.changeDetectorRef.detectChanges();
        if (this.waitCount > 0) {
          return (<PlayerPwaService>this.playerService).readyToInstall();
        } else {
          return of(true);
        }
      }),
      filter(res => res),
      take(1),
      switchMap(r => of(this.waitCount == 0))
    )
  }
}
